import { useThemeStore, themes, type ThemeId } from '@/stores/themeStore';
import { Check } from 'lucide-react';
import { cn } from '@/lib/utils';

export function ThemeSelector() {
  const { currentTheme, setTheme } = useThemeStore();

  return (
    <div className="space-y-3">
      <h3 className="text-xs font-medium text-muted-foreground uppercase tracking-wider">
        Theme
      </h3>

      <div className="space-y-1">
        {(Object.keys(themes) as ThemeId[]).map((themeId) => {
          const theme = themes[themeId];
          const isActive = currentTheme === themeId;

          return (
            <button
              key={themeId}
              onClick={() => setTheme(themeId)}
              className={cn(
                'w-full flex items-center gap-3 px-3 py-2.5 rounded-md transition-colors text-left',
                isActive
                  ? 'bg-primary/10 ring-1 ring-primary/30'
                  : 'hover:bg-accent/50'
              )}
            >
              <div className="flex-1 min-w-0">
                <span className="text-sm text-foreground">{theme.name}</span>
                <p className="text-[10px] text-muted-foreground">{theme.description}</p>
              </div>
              {isActive && <Check size={14} className="text-primary flex-shrink-0" />}
            </button>
          );
        })}
      </div>
    </div>
  );
}
